// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"97e9b022","787":"032859fc"}[chunkId] + ".chunk.js";
};